import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {legacy_createStore, compose, applyMiddleware, bindActionCreators} from 'redux';
import {rootReducer} from './rootReducer';
import thunk from 'redux-thunk';

import { iReduxState } from '../interfaces/interfaces';
import { isReduxShowed } from '../settings';

import * as appActionCreator from './app/appActions';
import * as UIActionCreator from './UI/UIActions';
import * as chromiaActionCreator from './chromia/chromiaActions';
import * as modalsActionCreator from './modals/modalsActions';

declare global{
	interface Window{
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : any;
	}
}

const composeEnhancers = (isReduxShowed && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
export const store = legacy_createStore(rootReducer, composeEnhancers(
	applyMiddleware(thunk)
));

export type tDispatch = typeof store.dispatch;

export const useStoreDispatch = () => {
	const dispatch = useDispatch();
	const allActionCreators = {
		...appActionCreator,
		...UIActionCreator,
		...chromiaActionCreator,
		...modalsActionCreator,
	};
	return bindActionCreators(allActionCreators, dispatch);
}

export const useStoreSelector: TypedUseSelectorHook<iReduxState> = useSelector; 